module.exports = __webpack_public_path__ + "static/img/18.082fdd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/18.png
// module id = 0e3m
// module chunks = 1